import moment from "moment";
export const isRegistrationClosed = (eventDate) => {
  if (!eventDate) return false;
  const cutoff = moment(eventDate, ["YYYY-MM-DD", moment.ISO_8601]).endOf(
    "day",
  );
  if (!cutoff.isValid()) return false;
  return moment().isAfter(cutoff);
};